module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-dpp.jpg?v=1f3cab06";